import BossModel from "@/models/BossModel";
import Element from "@/models/WebsitePage/Version/Element/Element";
import WidgetTemplate from "@/models/WebsiteWidget/WidgetTemplate";
import CustomerReview from "@/models/WebsiteWidget/CustomerReview/CustomerReview";
import Information from "@/models/WebsiteWidget/Information/Information";
import Title from "@/models/WebsiteWidget/Title/Title";
import ContactBlock from "@/models/WebsiteWidget/ContactBlock/ContactBlock";
import ExpertiseUser from "@/models/WebsiteWidget/ExpertiseUser/ExpertiseUser";
import MagazineRequest from "@/models/WebsiteWidget/MagazineRequest/MagazineRequest";
import ContactRequest from "@/models/WebsiteWidget/ContactRequest/ContactRequest";
import Blog from "@/models/WebsiteWidget/Blog/Blog";
import PhotoSlider from "@/models/WebsiteWidget/PhotoSlider/PhotoSlider";
import PhotoButton from "@/models/WebsiteWidget/PhotoButton/PhotoButton";
import Accordion from "@/models/WebsiteWidget/Accordion/Accordion";
import ProductBlock from "@/models/WebsiteWidget/ProductBlock/ProductBlock";
import CountryInformation from "@/models/WebsiteWidget/CountryInformation/CountryInformation";
import ProductSearchForm from "@/models/WebsiteWidget/ProductSearchForm/ProductSearchForm";
import CategoryShortcut from "@/models/WebsiteWidget/CategoryShortcut/CategoryShortcut";
import LegalContent from "@/models/WebsiteWidget/LegalContent/LegalContent";
import Gallery from "@/models/WebsiteWidget/Gallery/Gallery";
import WebsiteWidgetFeaturedArticle from "@/models/WebsiteWidget/FeaturedArticle/FeaturedArticle";

export default class WebsiteWidget extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgets';

    static fields() {
        return {
            id: this.number(null).nullable(),
            is_prefilled: this.boolean(null),
            name_intern: this.attr(null),
            widgetable_type: this.attr(null),
            widgetable_id: this.number(null).nullable(),
            elementsCount: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            elements: this.hasMany(Element, 'website_widget_id'),
            template: this.belongsTo(WidgetTemplate, 'widgetable_type', 'key'),
            website_widget_customer_review: this.belongsTo(CustomerReview, 'widgetable_id'),
            website_widget_information: this.belongsTo(Information, 'widgetable_id'),
            website_widget_title: this.belongsTo(Title, 'widgetable_id'),
            website_widget_contact_block: this.belongsTo(ContactBlock, 'widgetable_id'),
            website_widget_expertise_user: this.belongsTo(ExpertiseUser, 'widgetable_id'),
            website_widget_magazine_request: this.belongsTo(MagazineRequest, 'widgetable_id'),
            website_widget_contact_request: this.belongsTo(ContactRequest, 'widgetable_id'),
            website_widget_blog: this.belongsTo(Blog, 'widgetable_id'),
            website_widget_photo_slider: this.belongsTo(PhotoSlider, 'widgetable_id'),
            website_widget_photo_button: this.belongsTo(PhotoButton, 'widgetable_id'),
            website_widget_accordion: this.belongsTo(Accordion, 'widgetable_id'),
            website_widget_product_block: this.belongsTo(ProductBlock, 'widgetable_id'),
            website_widget_product_search_form: this.belongsTo(ProductSearchForm, 'widgetable_id'),
            website_widget_country_information: this.belongsTo(CountryInformation, 'widgetable_id'),
            website_widget_category_shortcut: this.belongsTo(CategoryShortcut, 'widgetable_id'),
            website_widget_legal_content: this.belongsTo(LegalContent, 'widgetable_id'),
            website_widget_gallery: this.belongsTo(Gallery, 'widgetable_id'),
            website_widget_featured_article: this.belongsTo(WebsiteWidgetFeaturedArticle, 'widgetable_id'),
        }
    }

    /**
     *
     * @param id
     * @returns {Promise<AxiosResponse<T>>}
     */
    static loadImplementations(id) {
        return this.api().action(id + '/implementations').get();
    }

    /**
     *
     * @param term
     * @returns {*}
     */
    static getAll(term = '') {
        if (term.length > 0) {
            let match = new RegExp(term, "gi");
            return this.all().filter(item => item.name_intern !== null &&
                (
                    item.name_intern.match(match) ||
                    item.WidgetTemplate().name.match(match) ||
                    item.WidgetTemplate().description.match(match)
                )
            );
        }
        return this.all();
    }

    /**
     *
     * @param term
     * @returns {*}
     */
    static getPrefilled(term) {
        return this.query().where((widget) => {
            return widget.name_intern && widget.name_intern.toLowerCase().includes(term.toLowerCase())
        }).where('is_prefilled', true).get();
    }

    /**
     *
     * @param widgetableType
     * @param widgetableId
     * @returns {*}
     */
    static byWidgetable(widgetableType, widgetableId) {
        return this.all().find(item => item.widgetable_id == widgetableId && item.widgetable_type == widgetableType);
    }

    /**
     *
     * @constructor
     */
    IncreaseElementsCount() {
        this.elementsCount++;
    }

    /**
     *
     * @constructor
     */
    DecreaseElementsCount() {
        this.elementsCount--;
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    WidgetTemplate() {
        return WidgetTemplate.byKey(this.widgetable_type);
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Widgetable() {
        if (this.widgetable_type !== null) {
            return this.getRelated(this.widgetable_type);
        }
        return false;
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Elements() {
        return this.getRelated('elements');
    }
}
